// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-manage {

    width: 100%;
}





/* 상단 */

.category-top {

    display: flex;

    flex-direction: column;

    gap: 18px;

    margin-bottom: 28px;
}





/* 검색 / 등록 영역 */

.category-search-wrap,
.category-create-wrap {

    display: flex;

    gap: 12px;
}





/* 입력 */

.category-input,
.category-edit-input {

    flex: 1 1;

    height: 54px;

    padding: 0 18px;

    border: none;

    outline: none;

    border-radius: 18px;

    background:

            rgba(255,255,255,0.05);

    border:

            1px solid rgba(255,255,255,0.08);

    color: white;

    font-size: 15px;

    backdrop-filter: blur(20px);

    transition: all 0.25s ease;
}





.category-input:focus,
.category-edit-input:focus {

    border-color:

            rgba(124,58,237,0.34);

    box-shadow:

            0 0 0 4px rgba(124,58,237,0.10);
}





.category-input::placeholder,
.category-edit-input::placeholder {

    color:

            rgba(255,255,255,0.34);
}





/* 버튼 */

.category-button,
.edit-button,
.delete-button,
.save-button,
.cancel-button {

    height: 54px;

    padding: 0 20px;

    border: none;

    border-radius: 18px;

    color: white;

    font-size: 14px;

    font-weight: 700;

    cursor: pointer;

    transition: all 0.25s ease;
}





/* 등록/검색 버튼 */

.category-button {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #0ea5e9
            );
}





.category-button:hover {

    transform: translateY(-2px);

    box-shadow:

            0 10px 24px rgba(124,58,237,0.24);
}





/* 수정 */

.edit-button {

    background:

            rgba(124,58,237,0.18);

    border:

            1px solid rgba(124,58,237,0.24);
}





.edit-button:hover {

    background:

            rgba(124,58,237,0.28);
}





/* 삭제 */

.delete-button {

    background:

            rgba(239,68,68,0.16);

    border:

            1px solid rgba(239,68,68,0.26);

    color: #f87171;
}





.delete-button:hover {

    background:

            rgba(239,68,68,0.24);
}





/* 저장 */

.save-button {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #0ea5e9
            );
}





.save-button:hover {

    transform: translateY(-2px);

    box-shadow:

            0 10px 24px rgba(124,58,237,0.24);
}





/* 취소 */

.cancel-button {

    background:

            rgba(255,255,255,0.08);
}





.cancel-button:hover {

    background:

            rgba(255,255,255,0.14);
}





/* 리스트 */

.category-list {

    display: flex;

    flex-direction: column;

    gap: 18px;
}





/* 카드 */

.category-card {

    padding: 24px;

    border-radius: 24px;

    background:

            linear-gradient(
                    180deg,
                    rgba(255,255,255,0.05),
                    rgba(255,255,255,0.02)
            );

    border:

            1px solid rgba(255,255,255,0.06);

    display: flex;

    justify-content: space-between;

    align-items: center;

    gap: 18px;

    transition: all 0.25s ease;

    backdrop-filter: blur(24px);
}





.category-card:hover {

    transform: translateY(-2px);

    border-color:

            rgba(124,58,237,0.22);

    background:

            linear-gradient(
                    180deg,
                    rgba(124,58,237,0.08),
                    rgba(255,255,255,0.03)
            );
}





/* 카테고리 이름 */

.category-name {

    color: white;

    font-size: 20px;

    font-weight: 800;

    letter-spacing: -0.03em;
}





/* 액션 */

.category-actions {

    display: flex;

    gap: 10px;

    flex-shrink: 0;
}





/* 수정 input */

.category-edit-input {

    margin-right: 10px;
}





/* 모바일 */

@media screen and (max-width: 768px) {

    .category-search-wrap,
    .category-create-wrap {

        flex-direction: column;
    }





    .category-card {

        flex-direction: column;

        align-items: stretch;
    }





    .category-actions {

        width: 100%;

        margin-top: 12px;
    }





    .edit-button,
    .delete-button,
    .save-button,
    .cancel-button {

        flex: 1 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategoryManage.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf;;;;;;AAMA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;;IAET,mBAAmB;AACvB;;;;;;AAMA,eAAe;;AAEf;;;IAGI,aAAa;;IAEb,SAAS;AACb;;;;;;AAMA,OAAO;;AAEP;;;IAGI,SAAO;;IAEP,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;;IAEnB;;kCAE8B;;IAE9B;;4CAEwC;;IAExC,YAAY;;IAEZ,eAAe;;IAEf,2BAA2B;;IAE3B,0BAA0B;AAC9B;;;;;;AAMA;;;IAGI;;iCAE6B;;IAE7B;;2CAEuC;AAC3C;;;;;;AAMA;;;IAGI;;kCAE8B;AAClC;;;;;;AAMA,OAAO;;AAEP;;;;;;IAMI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,0BAA0B;AAC9B;;;;;;AAMA,aAAa;;AAEb;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;6CAEyC;AAC7C;;;;;;AAMA,OAAO;;AAEP;;IAEI;;iCAE6B;;IAE7B;;2CAEuC;AAC3C;;;;;;AAMA;;IAEI;;iCAE6B;AACjC;;;;;;AAMA,OAAO;;AAEP;;IAEI;;gCAE4B;;IAE5B;;0CAEsC;;IAEtC,cAAc;AAClB;;;;;;AAMA;;IAEI;;gCAE4B;AAChC;;;;;;AAMA,OAAO;;AAEP;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;6CAEyC;AAC7C;;;;;;AAMA,OAAO;;AAEP;;IAEI;;kCAE8B;AAClC;;;;;;AAMA;;IAEI;;kCAE8B;AAClC;;;;;;AAMA,QAAQ;;AAER;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;AACb;;;;;;AAMA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;aAMS;;IAET;;4CAEwC;;IAExC,aAAa;;IAEb,8BAA8B;;IAE9B,mBAAmB;;IAEnB,SAAS;;IAET,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;iCAE6B;;IAE7B;;;;;;aAMS;AACb;;;;;;AAMA,YAAY;;AAEZ;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,uBAAuB;AAC3B;;;;;;AAMA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,SAAS;;IAET,cAAc;AAClB;;;;;;AAMA,aAAa;;AAEb;;IAEI,kBAAkB;AACtB;;;;;;AAMA,QAAQ;;AAER;;IAEI;;;QAGI,sBAAsB;IAC1B;;;;;;IAMA;;QAEI,sBAAsB;;QAEtB,oBAAoB;IACxB;;;;;;IAMA;;QAEI,WAAW;;QAEX,gBAAgB;IACpB;;;;;;IAMA;;;;;QAKI,SAAO;IACX;AACJ","sourcesContent":[".category-manage {\n\n    width: 100%;\n}\n\n\n\n\n\n/* 상단 */\n\n.category-top {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 18px;\n\n    margin-bottom: 28px;\n}\n\n\n\n\n\n/* 검색 / 등록 영역 */\n\n.category-search-wrap,\n.category-create-wrap {\n\n    display: flex;\n\n    gap: 12px;\n}\n\n\n\n\n\n/* 입력 */\n\n.category-input,\n.category-edit-input {\n\n    flex: 1;\n\n    height: 54px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    outline: none;\n\n    border-radius: 18px;\n\n    background:\n\n            rgba(255,255,255,0.05);\n\n    border:\n\n            1px solid rgba(255,255,255,0.08);\n\n    color: white;\n\n    font-size: 15px;\n\n    backdrop-filter: blur(20px);\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.category-input:focus,\n.category-edit-input:focus {\n\n    border-color:\n\n            rgba(124,58,237,0.34);\n\n    box-shadow:\n\n            0 0 0 4px rgba(124,58,237,0.10);\n}\n\n\n\n\n\n.category-input::placeholder,\n.category-edit-input::placeholder {\n\n    color:\n\n            rgba(255,255,255,0.34);\n}\n\n\n\n\n\n/* 버튼 */\n\n.category-button,\n.edit-button,\n.delete-button,\n.save-button,\n.cancel-button {\n\n    height: 54px;\n\n    padding: 0 20px;\n\n    border: none;\n\n    border-radius: 18px;\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n/* 등록/검색 버튼 */\n\n.category-button {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #0ea5e9\n            );\n}\n\n\n\n\n\n.category-button:hover {\n\n    transform: translateY(-2px);\n\n    box-shadow:\n\n            0 10px 24px rgba(124,58,237,0.24);\n}\n\n\n\n\n\n/* 수정 */\n\n.edit-button {\n\n    background:\n\n            rgba(124,58,237,0.18);\n\n    border:\n\n            1px solid rgba(124,58,237,0.24);\n}\n\n\n\n\n\n.edit-button:hover {\n\n    background:\n\n            rgba(124,58,237,0.28);\n}\n\n\n\n\n\n/* 삭제 */\n\n.delete-button {\n\n    background:\n\n            rgba(239,68,68,0.16);\n\n    border:\n\n            1px solid rgba(239,68,68,0.26);\n\n    color: #f87171;\n}\n\n\n\n\n\n.delete-button:hover {\n\n    background:\n\n            rgba(239,68,68,0.24);\n}\n\n\n\n\n\n/* 저장 */\n\n.save-button {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #0ea5e9\n            );\n}\n\n\n\n\n\n.save-button:hover {\n\n    transform: translateY(-2px);\n\n    box-shadow:\n\n            0 10px 24px rgba(124,58,237,0.24);\n}\n\n\n\n\n\n/* 취소 */\n\n.cancel-button {\n\n    background:\n\n            rgba(255,255,255,0.08);\n}\n\n\n\n\n\n.cancel-button:hover {\n\n    background:\n\n            rgba(255,255,255,0.14);\n}\n\n\n\n\n\n/* 리스트 */\n\n.category-list {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 18px;\n}\n\n\n\n\n\n/* 카드 */\n\n.category-card {\n\n    padding: 24px;\n\n    border-radius: 24px;\n\n    background:\n\n            linear-gradient(\n                    180deg,\n                    rgba(255,255,255,0.05),\n                    rgba(255,255,255,0.02)\n            );\n\n    border:\n\n            1px solid rgba(255,255,255,0.06);\n\n    display: flex;\n\n    justify-content: space-between;\n\n    align-items: center;\n\n    gap: 18px;\n\n    transition: all 0.25s ease;\n\n    backdrop-filter: blur(24px);\n}\n\n\n\n\n\n.category-card:hover {\n\n    transform: translateY(-2px);\n\n    border-color:\n\n            rgba(124,58,237,0.22);\n\n    background:\n\n            linear-gradient(\n                    180deg,\n                    rgba(124,58,237,0.08),\n                    rgba(255,255,255,0.03)\n            );\n}\n\n\n\n\n\n/* 카테고리 이름 */\n\n.category-name {\n\n    color: white;\n\n    font-size: 20px;\n\n    font-weight: 800;\n\n    letter-spacing: -0.03em;\n}\n\n\n\n\n\n/* 액션 */\n\n.category-actions {\n\n    display: flex;\n\n    gap: 10px;\n\n    flex-shrink: 0;\n}\n\n\n\n\n\n/* 수정 input */\n\n.category-edit-input {\n\n    margin-right: 10px;\n}\n\n\n\n\n\n/* 모바일 */\n\n@media screen and (max-width: 768px) {\n\n    .category-search-wrap,\n    .category-create-wrap {\n\n        flex-direction: column;\n    }\n\n\n\n\n\n    .category-card {\n\n        flex-direction: column;\n\n        align-items: stretch;\n    }\n\n\n\n\n\n    .category-actions {\n\n        width: 100%;\n\n        margin-top: 12px;\n    }\n\n\n\n\n\n    .edit-button,\n    .delete-button,\n    .save-button,\n    .cancel-button {\n\n        flex: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
